<template>
  <el-form
    :model="passwordForm"
    :rules="rules"
    label-position="right"
    ref="passwordForm"
    class="passwordForm"
    size="mini"
  >
    <!-- 原密码 -->
    <el-form-item label="请输入原密码" prop="origin_password">
      <el-input
        type="text"
        v-model="passwordForm.origin_password"
        autocomplete="off"
        placeholder="6-20位英文大小写或数字"
        show-password
      ></el-input>
    </el-form-item>
    <el-form-item label="请输入新密码" prop="new_password" show-password>
      <el-input
        type="text"
        v-model.trim="passwordForm.new_password"
        autocomplete="off"
        placeholder="6-20位英文大小写或数字"
        show-password
      ></el-input>
    </el-form-item>
    <el-form-item
      label="请再次输入新密码"
      prop="confirm_password"
      show-password
    >
      <el-input
        type="text"
        v-model.trim="passwordForm.confirm_password"
        autocomplete="off"
        placeholder="请输入与上方一致的密码"
        show-password
      ></el-input>
    </el-form-item>
    <el-form-item style="text-align: right">
      <el-button @click="$emit('close')">取消</el-button>
      <el-button type="primary" @click="submitForm('password')">提交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.passwordForm.confirm_password !== "") {
          this.$refs.passwordForm.validateField("confirm_password");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.passwordForm.new_password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      // 密码修改表单
      passwordForm: {
        origin_password: "",
        new_password: "",
        confirm_password: "",
      },
      rules: {
        new_password: [
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "请填写6-20位数字或英文字母,区分大小写",
          },
          {
            min: 6,
            max: 20,
            trigger: "blur",
            message: "请填写6-20位数字或英文字母,区分大小写",
          },
          { validator: validatePass, trigger: "blur" },
        ],
        confirm_password: [{ validator: validatePass2, trigger: "blur" }],
        origin_password: [
          { required: true, message: "必填", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "请填写6-20位数字或英文字母,区分大小写",
          },
          {
            min: 6,
            max: 20,
            trigger: "blur",
            message: "请填写6-20位数字或英文字母,区分大小写",
          },
        ],
      },
      // sonInfo: {},
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 弹框确定按钮
    submitForm(str) {
      this.$refs.passwordForm.validate(async (valid) => {
        if (valid) {
          await this.$store.dispatch("user/resetPassword", this.passwordForm);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-form-item__error {
  top: 84%;
}
</style>
